// Shared exam/question contract between the admin panel and the mobile app.
// The mobile app maps `questionType` through QuestionType in
// framework/features/content/lib/exams/data/exam_entity.dart — keep the numbers in sync.

export const QUESTION_TYPE = {
  image: 1,
  sound: 2,
  text: 3,
  essay: 4, // مقالي — the student writes the answer, the teacher grades it by hand
};

export const QUESTION_TYPE_OPTIONS = [
  { value: QUESTION_TYPE.text, label: "إدخال نص" },
  { value: QUESTION_TYPE.image, label: "إدخال صورة" },
  { value: QUESTION_TYPE.essay, label: "سؤال مقالي" },
];

// Status of a student's result document: Exams/{examId}/results/{userId}
export const RESULT_STATUS = {
  pending: "pending", // at least one essay answer still needs a mark
  graded: "graded",
};

export const DEFAULT_QUESTION_DEGREE = 1;

export function isEssayQuestion(question) {
  return Number(question?.questionType) === QUESTION_TYPE.essay;
}

// A fresh question object. Never reuse an existing one: the form binds to it,
// so handing back an object that is already inside exam.questions makes the
// form and the table row the same object.
export function blankQuestion(questionType = QUESTION_TYPE.text) {
  return {
    type: 3, // content type: exam
    title: "",
    url: "",
    isRight: null, // index (0..3) of the correct answer; unused for essays
    questionType,
    degree: DEFAULT_QUESTION_DEGREE,
    answers: [{ title: "" }, { title: "" }, { title: "" }, { title: "" }],
  };
}

// An essay question carries a single answer: the model answer the teacher
// grades against.
export function blankEssayQuestion() {
  return {
    ...blankQuestion(QUESTION_TYPE.essay),
    answers: [{ title: "" }],
  };
}

export function cloneQuestion(question) {
  return JSON.parse(JSON.stringify(question));
}

// The exam total is the sum of its questions' marks — never typed by hand.
export function questionsTotalDegree(questions) {
  if (!Array.isArray(questions)) return 0;
  return questions.reduce((total, question) => {
    const degree = Number(question?.degree);
    return total + (Number.isFinite(degree) ? degree : 0);
  }, 0);
}

// Validates a question before it is added to the exam.
// Returns null when valid, or an Arabic error message.
export function validateQuestion(question) {
  const type = Number(question?.questionType);

  if (type === QUESTION_TYPE.image) {
    if (!question.url && !question.file) return "قم برفع صورة السؤال";
  } else if (!question.title || !String(question.title).trim()) {
    return "اكتب رأس السؤال";
  }

  const degree = Number(question?.degree);
  if (!Number.isFinite(degree) || degree <= 0) {
    return "درجة السؤال يجب أن تكون أكبر من صفر";
  }

  if (type === QUESTION_TYPE.essay) return null;

  const answers = question?.answers ?? [];
  if (answers.length < 2) return "السؤال يحتاج اجابتين على الأقل";
  if (answers.some((answer) => !answer?.title || !String(answer.title).trim())) {
    return "اكمل كل الاجابات";
  }
  if (
    question.isRight === null ||
    question.isRight === false ||
    question.isRight === "" ||
    question.isRight === undefined
  ) {
    return "اختار الاجابة الصحيحة";
  }

  return null;
}
